// @ts-nocheck
import * as Types from '../../../../generated/graphqlTypes';

import { gql } from '@apollo/client';
import { ApproverUserDetailFragmentDoc } from '../../../../fragments/circularFragments.generated';
export type ApprovalSubject_InvoiceFragment = { __typename?: 'Invoice', id: string, name: string, blueprintUrl: { __typename?: 'Url', path: string }, predictedApprovers: Array<{ __typename?: 'Client', id: string, name: string } | { __typename?: 'InternalUser', id: string, avatar: string, name: string } | { __typename?: 'TradePartnerUser', id: string, name: string, tradePartner: { __typename?: 'TradePartner', id: string, name: string } }>, project: { __typename?: 'StandaloneProject', id: string, name: string } | { __typename?: 'Region', id: string, name: string } | { __typename?: 'Market', id: string, name: string } | { __typename?: 'Community', id: string, name: string } | { __typename?: 'Subdivision', id: string, name: string } | { __typename?: 'Lot', id: string, name: string } | { __typename?: 'Structure', id: string, name: string } | { __typename?: 'Unit', id: string, name: string } };

export const ApprovalSubject_InvoiceFragmentDoc = gql`
    fragment ApprovalSubject_Invoice on Invoice {
  id
  name
  blueprintUrl {
    path
  }
  predictedApprovers {
    ...ApproverUserDetail
  }
  project {
    id
    name
  }
}
    ${ApproverUserDetailFragmentDoc}`;